export default __webpack_public_path__ + "b95d57c74b7cbf3a56374b1f048ccf83.png";